import styled from "styled-components";
export const TextEditorBox = styled.div`
  background-color: ${props => props.disabled ? props.theme.colors.buttonPrimaryBgDisabled : props.theme.colors.inputBg};
  border: ${props => props.theme.borders.input};
  border-radius: 4px 4px 0 0;
  box-sizing: border-box;
  color: ${props => props.theme.colors.inputText};
  display: block;
  ${props => props.theme.fonts.default};
  font-size: 17px;
  min-height: 160px;
  line-height: 24px;
  outline: 0;
  padding: 7px 12px;
  width: 100%;
  z-index: 2;
  -webkit-appearance: none;
  &::placeholder {
    color: ${props => props.theme.colors.inputPlaceholderText};
    font-size: 12px;
  }
  &:focus {
    border-color: ${props => props.theme.colors.action};
    box-shadow: 0 0 4px 0 ${props => props.theme.colors.action};
  }
  &:disabled {
    border-color: ${props => props.theme.colors.buttonPrimaryTextDisabled};
  }
  ${props => props.error && `background-color: ${props.theme.colors.inputErrorBg};`}

  ${props => (props.warning || props.error) && `border-color: ${props.theme.colors.inputErrorBorder};
    border-width: 2px;
    padding-top: 6px;
    padding-bottom: 6px;
    &:focus {
      border-color: ${props => props.theme.colors.action}; }`}
`;